import { render, staticRenderFns } from "./ToolbarDashboard.vue?vue&type=template&id=5bf0a06d&scoped=true&"
import script from "./ToolbarDashboard.vue?vue&type=script&lang=js&"
export * from "./ToolbarDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ToolbarDashboard.vue?vue&type=style&index=0&id=5bf0a06d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf0a06d",
  null
  
)

export default component.exports